var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mobileFilterIsActive === false
    ? _c(
        "div",
        {
          staticClass:
            "bottom-button fixed-bottom d-flex d-md-none justify-content-end w-100 p-2",
        },
        [
          _vm.selectedJobPosting !== undefined
            ? [
                _c(
                  "b-button",
                  {
                    staticClass: "btn rounded",
                    attrs: { variant: "light" },
                    on: {
                      click: function ($event) {
                        return _vm.goToPage(_vm.selectedJobPosting.Url)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.t.jobSearch_V2_Go_To_Job))]
                ),
                _vm.jobmatch === true &&
                _vm.content.navigateToJobApplication &&
                _vm.jobApplicationAccess === true
                  ? _c(
                      "b-button",
                      {
                        staticClass: "rounded ml-2",
                        attrs: { variant: "light" },
                        on: {
                          click: function ($event) {
                            return _vm.goToJobApplication(
                              _vm.selectedJobPosting.JobId
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.t.jobmatch_Go_To_Job_Application))]
                    )
                  : _vm._e(),
              ]
            : [
                _vm.content !== undefined && _vm.content.jumpToWizardStepLink
                  ? _c(
                      "a",
                      {
                        staticClass: "decorations-none",
                        attrs: {
                          href:
                            _vm.content.backToJobWizardLinkPicker +
                            "?jumpToStep=" +
                            _vm.content.jumpToWizardStepLink,
                        },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass:
                              "btn-brand-light mr-2 d-flex align-items-center px-2 px-md-4",
                          },
                          [
                            _c("b-icon", {
                              staticClass: "mr-2",
                              attrs: { icon: _vm.iconOnJumpToStepButton },
                            }),
                            _vm._v(_vm._s(_vm.content.jumpToWizardStepText)),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.content !== undefined
                  ? _c(
                      "a",
                      {
                        attrs: { href: _vm.content.backToJobWizardLinkPicker },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass:
                              "btn-brand-light px-2 px-md-4 mr-1 mr-md-0",
                            on: { click: _vm.changeJobMatchProfile },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c("b-icon", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    icon: "pencil-square",
                                    variant: "white",
                                    "font-scale": "1.2",
                                  },
                                }),
                                _vm._v(
                                  _vm._s(_vm.content.backToJobWizardButtonText)
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }